import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"
import { Element } from "../element"

// Version 1 ---------------------
export const VideoSettingsV1 = z.object({
  src: z.string(),
  paddingTop: z.string(),
  overlayColor: z.string(),
  justifyContent: z.string(),
  bleed: z.union([z.literal(true), z.literal(false)]),
  lightBleed: z.union([z.literal(true), z.literal(false)]),
  style: z.string(),
  width: z.string(),
  height: z.string(),
})

export type TVideoSettingsV1 = z.infer<typeof VideoSettingsV1>

export const VideoElementV1 = z.object({
  id: z.string(),
  name: z.literal("video"),
  settings: VideoSettingsV1,
  container: ContainerOptionsV1,
  children: z.lazy(() => z.array(Element)),
})

export type TVideoElementV1 = z.infer<typeof VideoElementV1>

// Version 2 ---------------------
export const VideoSettingsV2 = z.object({
  src: z.string(),
  paddingTop: z.string(),
  overlayColor: z.string(),
  justifyContent: z.string(),
  bleed: z.union([z.literal(true), z.literal(false)]),
  lightBleed: z.union([z.literal(true), z.literal(false)]),
  style: z.string(),
  width: z.string(),
  height: z.string(),
  aspectSize: z.union([z.literal("contain"), z.literal("cover")]),
})

export type TVideoSettingsV2 = z.infer<typeof VideoSettingsV2>

export const VideoElementV2 = z.object({
  id: z.string(),
  name: z.literal("video"),
  settings: VideoSettingsV2,
  container: ContainerOptionsV1,
  children: z.lazy(() => z.array(Element)),
})

export type TVideoElementV2 = z.infer<typeof VideoElementV2>

// Latest ---------------------
export const VideoSettings = VideoSettingsV2
export type TVideoSettings = TVideoSettingsV2
export const VideoElement = VideoElementV2
export type TVideoElement = TVideoElementV2
